<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-title"><a id="page_14">Introduction</a></h2><a id="page_14">
<p class="noindent">If you love crafting of all kinds, <em class="italic">100 Little Christmas Gifts to Make</em> is the book for you. Packed full of quick and easy projects, you can make Christmas gifts for the whole family and all your friends! Choose from Stitching, Papercraft, Knitting, Jewellery making, Crochet, Sugarcraft and Polymer Clay modelling to make fabulous presents – there is such a variety that there is something to appeal to everyone.</p>
<p class="indent">There are useful Know-how sections at the beginning of each separate craft to give you information on materials, tools and techniques needed to make the projects.</p>
<p class="indent">From the Stitching projects you can make a Felt Winter Owl, a Pompom Santa or a Jelly Roll Bag; from the Papercraft projects, make a Christmas Tree Papercut, a Quilled Reindeer or a Washi Tape Card; the Knitting projects offer a Twinkling Star, some Frosty Wrist Warmers and some Penguin Boot Cuffs; the Jewellery projects include a Steampunk Butterfly, a Pewter Heart Necklace and a Statement Ring; the Crochet projects offer a Glittery Beanie hat, a Christmas Star and a Festive Wreath; from the Sugarcraft projects you can make a Christmas Rose, a Winter Fairy and some Elf Boots; and from the Polymer Clay projects, you can make a Christmas Bear, a Cupcake Button and a Gingerbread Charm.</p>
<p class="indent">These are just a selection of the projects that you can make, designed by some of Search Press’s most successful authors including Sue Stratford, Frances McNaughton, Val Pierce, Carolyn Schulz, Susie Johns and Alistair Macdonald.</p>
<p class="indent">What could be more satisfying than gifts that you have made yourself for family and friends at Christmas time!</p>
<p class="indent">Happy crafting!</p>
</a><div class="figure"><a id="page_14"></a><a id="page_15">
<img alt="" src="images/pg9.jpg"/>
</a></div><a id="page_15">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Introduction.vue?738141e8